  <template>
  <v-footer class="background-footer">
    <v-container>
      <v-row>
        <v-col cols="7">
          <v-btn text small  style="text-transform: none !important;" @click="privacyNotice()">Aviso de privacidad</v-btn>
        </v-col>
        <v-col cols="3" class="pt-9 position">
          <span class="font-weight-bold subtitle-footer">Una empresa de</span>
        </v-col>
        <v-col cols="2">
          <v-img :src="logoGE" height="80" contain/>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    logoGE: require('@/assets/logo-GE.png'),
  }),
   methods: {
     privacyNotice(){
       this.$router.push('/privacyNotice')
     }

   }
}
</script>

<style scoped>
  .subtitle-footer {
    color: #01579B;
  }
  .position{
    text-align: right!important;
  }
  .background-footer {
    background-color: white !important;
  }
</style>
